<template>
  <div class="api-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-select
            v-model="searchInfo.companyId"
            placeholder="请选择"
            style="width: 160px; display: inline-block"
          >
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.company_name"
              :value="item.company_id"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="searchInfo.roleName"
            placeholder="请输入角色名称"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button type="text" @click="tipDialogVisible = true"
            >帮助提示</el-button
          >
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="editRole()"
            v-hasPermi="['权限管理', '新增']"
            >新增角色</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="角色"
          min-width="140"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="userNum"
          label="成员数量"
          min-width="250"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column label="状态" align="center" key="is_del">
          <template #default="scope">
            <el-switch
              v-model="scope.row.is_del"
              active-value="0"
              inactive-value="2"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column prop="description" label="角色描述" align="center">
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" align="center">
        </el-table-column>
        <el-table-column label="操作" width="400" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                @click="addAccountDialog(scope.row)"
                v-hasPermi="['权限管理', '添加账户']"
                >添加账户</span
              >
              <span
                class="btn read"
                @click="editRole(scope.row, 1)"
                v-hasPermi="['权限管理', '编辑']"
                >编辑角色</span
              >
              <span
                class="btn read"
                v-hasPermi="['权限管理', '设置权限']"
                @click="
                  $router.push({
                    path: 'setauth',
                    query: scope.row,
                  })
                "
                >设置权限</span
              >
              <span
                class="btn read"
                @click="handleStatusChange(scope.row)"
                v-hasPermi="['权限管理', '添加账户']"
                >{{ scope.row.is_del == 0 ? "停用角色" : "启用角色" }}</span
              >
              <span
                class="btn read"
                @click="deleteClick(scope.row)"
                v-hasPermi="['权限管理', '删除']"
                >删除角色</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="searchInfo.pageNum"
          :page-pageSize="searchInfo.pageSize"
          :total="table.total"
          @current-change="currentChange"
          @pageSize-change="handlepageSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="帮助提示"
      :close-on-click-modal="false"
      :visible.sync="tipDialogVisible"
      width="500px"
    >
      <div class="tip-content">
        <div>
          1、角色代表操作权限和数据权限，操作权限是指具有该职务的用户是否能查看、新增、编辑、
          删除某些数据，数据权限是指具有该角色的用户能操作的数据的范围；
        </div>
        <div>2、超级管理员的权限是系统默认的最大权限的角色，不能修改；</div>
        <div>3、需要删除角色时必须先清除该角色下的所有成员；</div>
      </div>
    </el-dialog>
    <el-dialog
      title="添加账户"
      :visible.sync="addAccountDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="accountForm" :model="addAccountInfo" :rules="rules">
        <el-form-item>
          <el-select
            v-model="level"
            placeholder="请选择账号级别"
            style="width: 100%"
            @change="getAccountList()"
          >
            <el-option
              v-for="item in levelList"
              :key="item.level"
              :label="item.label"
              :value="item.level"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="userIds">
          <el-select
            v-model="addAccountInfo.userIds"
            multiple
            placeholder="请选择账号"
            style="width: 100%"
          >
            <el-option
              v-for="item in accountList"
              :key="item.id"
              :label="item.department"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="saveAccount('accountForm')"
          >保存</el-button
        >
        <el-button @click="addAccountDialogVisible = false">取消</el-button>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="roleTitle"
      :visible.sync="roleDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="roleForm"
        :model="addeditInfo"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="角色" prop="name">
          <el-input v-model="addeditInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="description">
          <el-input v-model="addeditInfo.description"></el-input>
        </el-form-item>
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="saveRole('roleForm')"
          >保存</el-button
        >
        <el-button @click="roleDialogVisible = false">取消</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import {
  getCompanys, getRoleList, addRole, updateRole, upRoleStatus,
  getAddUsers, addRUsers
} from '@/api/role'
export default {
  data () {
    return {
      loading: false,
      table: {
        data: [],
        height: 100,
        pageNum: 1,
        pageSize: 50,
        total: 0
      },
      tipDialogVisible: false,
      addAccountDialogVisible: false,
      roleDialogVisible: false,
      roleTitle: '新增角色',
      companyList: [],
      searchInfo: {
        companyId: '',
        roleName: '',
        pageNum: 1,
        pageSize: 50
      },
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        userIds: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
      },
      addeditInfo: {
        name: '',
        description: ''
      },
      btnLoading: false,
      level: 1,
      levelList: [{ label: '超级管理员', level: 1 },
      { label: '公司总账号', level: 2 },
      { label: '部门账号', level: 3 }],
      addAccountInfo: {
        userIds: [],
        id: ''
      },
      accountList: [],
      beforeUrl: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.beforeUrl = from.path.split('/')[1]
    })
  },
  mounted () {
    this.getCompanysData()
    // this.getRoleListData()
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onrepageSize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
  },
  methods: {
    addAccountDialog (val) {
      this.addAccountInfo.id = val.id
      this.addAccountInfo.userIds = []
      this.addAccountDialogVisible = true
    },
    //获取账号列表
    getAccountList () {
      let params = {
        level: this.level,
        companyId: this.searchInfo.companyId,
      }
      getAddUsers(params).then(da => {
        this.accountList = da.data
      })
    },
    saveAccount (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          this.btnLoading = true
          let params = JSON.parse(JSON.stringify(this.addAccountInfo))
          params.userIds = params.userIds.join(',')
          addRUsers(params).then(da => {
            if (da.code === 0) {
              this.$message.success('添加成功')
              this.getRoleListData()
              this.addAccountDialogVisible = false
            }
          }).finally(() => {
            this.btnLoading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveRole (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          this.btnLoading = true
          if (this.roleTitle === '编辑角色') {
            updateRole(this.addeditInfo).then(da => {
              if (da.code === 0) {
                this.$message.success('编辑成功')
                this.getRoleListData()
                this.roleDialogVisible = false
              }
            }).finally(() => {
              this.btnLoading = false
            })
          } else {
            addRole(this.addeditInfo).then(da => {
              if (da.code === 0) {
                this.$message.success('新增成功')
                this.getRoleListData()
                this.roleDialogVisible = false
              }
            }).finally(() => {
              this.btnLoading = false
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //获取公司
    getCompanysData () {
      getCompanys().then(da => {
        this.companyList = da.data
        if (this.companyList.length > 0) {
          this.searchInfo.companyId = this.companyList[0].company_id
          this.getRoleListData()
        }
      })
    },
    //获取角色列表
    getRoleListData () {
      getRoleList(this.searchInfo).then(da => {
        this.table.data = da.data.content
        this.table.total = da.data.total
      })
    },
    editRole (val, type) {
      if (type) {
        this.addeditInfo.id = val.id
        this.addeditInfo.name = val.name
        this.addeditInfo.description = val.description
        this.roleTitle = "编辑角色"
      } else {
        this.addeditInfo.name = ''
        this.addeditInfo.description = ''
        this.addeditInfo.level = ''
        this.addeditInfo.belong_company = this.searchInfo.companyId
        this.roleTitle = "新增角色"
      }
      this.roleDialogVisible = true
    },
    // 用户状态修改
    handleStatusChange (row) {
      if (!row.id) {
        return
      }
      let text = row.is_del == 0 ? "停用" : "启用";
      let that = this
      MessageBox.confirm('确认要"' + text + '""' + row.name + '"用户吗?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        let status = 0
        if (row.is_del == 0) {
          status = 2
        }
        upRoleStatus({ id: row.id, status }).then(da => {
          if (da.code === 0) {
            that.$message.success(text + "成功");
            that.getRoleListData()
          }
        });
      })
    },
    search () {
      this.table.pageNum = 1
      this.getRoleListData()
    },
    currentChange () {
      this.getRoleListData()
    },
    handlepageSizeChange (e) {
      this.searchInfo.pageNum = 1
      this.searchInfo.pageSize = e
      this.getRoleListData()
    },
    dealClick (id) {
      MessageBox.confirm('确认解决?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      }).catch(() => {
        // this.$message('已取消注销')
      });
    },
    deleteClick (row) {
      MessageBox.confirm('此操作将删除' + row.name + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = { id: row.id, status: 1 }
        upRoleStatus(param).then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功!')
            this.refresh()
          }
        })
      }).catch(() => {
        this.$message('已取消注销')
      });
    },
    refresh () {
      this.getRoleListData()
    }
  },
  watch: {
    beforeUrl () {
      if (this.beforeUrl == 'gotoOther') {
        return
      }
      this.$nextTick(() => {
        if (this.beforeUrl !== 'authority') {
          this.getCompanysData()
        } else {
          this.getRoleListData()
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.beforeUrl = 'gotoOther'
    next()
  }


}
</script>

<style lang="less" scoped>
.api-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
  .tip-content {
    color: #acacac;
  }
}
</style>
<style lang="less">
.api-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
